import { pathJoin } from 'src/reducers/routing/utils'

export const createCollectionCalendarDetailViewRoutesMap = (
  prefix: string
) => ({
  configuration: pathJoin(prefix)('configuration').chain,
  'collection-calendar-days': pathJoin(prefix)('collection-calendar-days')
    .chain,
})
